import * as React from 'react';

function SvgCusdLogo(props) {
  return (
    <svg
      width={100}
      height={100}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="50" cy="50" r="50" fill="#5AAD91" />
      <path
        d="M44.9037 87.6865L49.6388 88.0335L49.2741 93.0101L44.539 92.6631L44.9037 87.6865Z"
        fill="#FDFAF3"
      />
      <path
        d="M56.2079 2.79591L65.6199 12.0463L52.8132 15.2313L56.2079 2.79591Z"
        fill="#F8AEA5"
        stroke="#FDFAF3"
        strokeWidth="1.5"
      />
      <path
        d="M43.2424 96.2593L33.8304 87.009L46.6371 83.824L43.2424 96.2593Z"
        fill="#F8AEA5"
        stroke="#FDFAF3"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.5 6C51.8397 6 53.1652 6.06056 54.4741 6.1791L53.3211 11.1018C52.3895 11.0343 51.4488 11 50.5 11C29.237 11 12 28.237 12 49.5C12 63.9787 19.9924 76.5907 31.8059 83.1648L30.6255 88.2047C16.5961 80.9861 7 66.3637 7 49.5C7 25.4756 26.4756 6 50.5 6ZM46.1161 92.7818C47.5578 92.9261 49.0203 93 50.5 93C74.5244 93 94 73.5244 94 49.5C94 32.1648 83.8599 17.198 69.1875 10.2074L68.0166 15.2065C80.4735 21.582 89 34.5453 89 49.5C89 70.763 71.763 88 50.5 88C49.4113 88 48.3332 87.9548 47.2674 87.8662L46.1161 92.7818Z"
        fill="#FDFAF3"
      />
      <path
        d="M60 41H69C69 31 65.5 24 49.5 24C33.5 24 31.1186 34.502 31 38C30.8643 42.0036 34.8603 54.5238 49.5 54C61.0926 53.5852 62.5 59.6667 62 62.5C62.1667 64.8333 60.2953 68.683 49.5 69C39.2679 69.3004 38.1388 62.1715 38.5 58H30C30 74 39 76 49.5 76C60 76 70 74.5 70 62.5C70 50.5 59.4969 46.2483 49.5 46C39.6515 45.7554 39.1189 38.3077 39 38C38.8198 37.5336 37.0001 30.5435 49.5 30.5C60.0569 30.4632 60.9377 37.4601 60 41Z"
        fill="#FDFAF3"
      />
      <rect x="47" y="19" width="5" height="61" fill="#FDFAF3" />
    </svg>
  );
}

export default SvgCusdLogo;
